<template lang="pug">
  v-dialog(v-model="show", max-width="500", persistent)
    div(style="background-color: white; padding: 20px; ")
      h3.font-weight-bold Taxa de serviço
      p.mt-4 A taxa de serviço é um valor cobrado do cliente e será repassado à plataforma após o pagamento do pedido.
      v-card-actions
        v-spacer
        v-btn(@click="close", color="accent") Entendi
</template>


<script>

export default {
  data: () => ({
    show: false
  }),
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    }
  }
}
</script>
